<form [formGroup]="formGroup" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective" autocomplete="off">
  <div class="new-hv-paket-detail-item" [ngClass]="{'hv-paket-hidden': previewPaket?.Id !== paket.Id}">
    <div class="new-hv-paket-icon-container">
      <div class="new-hv-paket-icon-big" [ngClass]="{'new-hv-paket-icon-selected': selected.value}">
        <img src="{{ dataService.hvPaketIcons.get(paket.Kategorie) }}">
      </div>
      <div class="new-hv-paket-selection-button" [ngClass]="{'hv-paket-select-button-selected' : selected.value}">
        <button mat-button class="button--secondary" type="button" (click)="selectPaket()">
          {{ selected.value ? 'Ausgewählt' : 'Auswählen' }}
        </button>
      </div>
    </div>
    <div class="new-hv-paket-text-big">
      <div class="new-hv-paket-title">
        {{ paket.Titel }}
        <div *ngIf="getPraemie() as praemie" class="hv-paket-praemie">
          <div class="praemie">
            {{ praemie | customCurrency }}
          </div>
          <div class="periode">
            &nbsp;pro Jahr
          </div>
        </div>
      </div>
      <div class="new-hv-paket-description">{{ dataService.hvPaketTeaserTexte.get(paket.Kategorie) }}</div>
      <div class="new-hv-paket-download-factsheet">
        <div class="icon--before icon--download">&nbsp;&nbsp;&nbsp;<a [href]="getHvPaketFactsheets(produktart, paket.Kategorie) | async" class="textLink" target="blank">Informationsblatt herunterladen</a></div>
      </div>
      <div class="new-hv-paket-inputs">
        <div class="input" *ngIf="showVersicherungssumme">
          <app-label [control]="versicherungssumme" class="input__label" for="versicherungssumme">Versicherungssumme:</app-label>
          <mat-form-field>
            <mat-select [compareWith]="lookupService.compareValues" id="versicherungssumme" placeholder="Versicherungssumme" formControlName="versicherungssumme">
              <mat-option *ngFor="let vs of paket.Versicherungssummen" [value]="vs">{{ vs.Value }}</mat-option>
            </mat-select>
            <mat-error *ngIf="versicherungssumme.hasError('required')">{{ 'SELECTREQUIRED' | translate }}</mat-error>
          </mat-form-field>
        </div>
        <div class="input" *ngIf="showGeltungsbereicheVersicherungssummen">
          <app-label [control]="geltungsbereicheVersicherungssummen" class="input__label" for="geltungsbereicheVersicherungssummen">Geltungsbereich und Versicherungssumme:</app-label>
          <div class="label-infotext" *ngIf="dataService.hvPaketGeltungsbereichVsSubTexte.get(paket.Id)">{{ dataService.hvPaketGeltungsbereichVsSubTexte.get(paket.Id) }}</div>
          <mat-form-field>
            <mat-select [compareWith]="lookupService.compareValues" id="geltungsbereicheVersicherungssummen" placeholder="Geltungsbereich und Versicherungssumme" formControlName="geltungsbereicheVersicherungssummen">
              <mat-option *ngFor="let gv of paket.GeltungsbereicheVersicherungssummen" [value]="gv">{{ gv.Value }}</mat-option>
            </mat-select>
            <mat-error *ngIf="geltungsbereicheVersicherungssummen.hasError('required')">{{ 'SELECTREQUIRED' | translate }}</mat-error>
          </mat-form-field>
        </div>
        <app-partner [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="partner" [privatperson]="true" idprefix="student" [showGroup]="showPartner" [student]="true"></app-partner>
      </div>
    </div>
  </div>
</form>
